import { useEffect, useRef, useState } from "react";
import { CardWrapper, CardTitle, CardBody, CardButton } from "./style";

export const HistoryCard = ({
  title = "title",
  content = "content",
  buttonText = "back",
  id = null,
  onClick = () => {},
  last = false
}) => {
  const [over, setOver] = useState(false);
  return (
    <CardWrapper
      {...{
        id,
        last,
        onMouseEnter: () => setOver(true),
        onMouseLeave: () => setOver(false),
      }}
    >
      <CardTitle>
        <div>{title}</div>{" "}
        <CardButton {...{ onClick, isHover: over }}>{buttonText}</CardButton>
      </CardTitle>

      {/* <CardBody>{content}</CardBody> */}
    </CardWrapper>
  );
};
